export default __webpack_public_path__ + "bfd0e7438df1f7e2012d338bd294d88c.jpg";